// Edit the shared order and globally hidden products here.
export const catalogDefaults = Object.freeze({
  order: Object.freeze([
    'user',
    'surfer',
    'signitic',
    'iconosquare',
    'humanlinker',
    'nocrm',
    'ubic',
  ]),
  hiddenProducts: Object.freeze([]),
});
